import logo from './logo.svg';
import './App.css';
import Movenet from './components/test/Movenet';
import Visualizer from './components/Visualizer';
import Anime from './components/test/Anime';
import "./assets/vendor/nucleo/css/nucleo.css";
import "./assets/vendor/font-awesome/css/font-awesome.min.css";
import "./assets/css/argon-design-system-react.css";
import { BrowserRouter as Router,Routes,Route, Outlet, Link } from 'react-router-dom';
import TestCam from './components/test/TestCam';
import Detector from './components/Detector';
import {Navbar,Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, CardFooter, NavbarBrand} from "reactstrap";
import React, { useEffect, useState } from 'react';
import {ENGLISH,FRENCH} from './util/texts'
import { base_url } from './util/GlobalConfigs';
require('flag-icons');
export const LanguageContext = React.createContext(ENGLISH)
export const LanguageContextConsumer = LanguageContext.Consumer

function App() {
  const [language,setLanguage] = useState('en')
  const [texts,setTexts] = useState(ENGLISH)
  const [dropdownOpen,setDropdownOpen] = useState(false)
  
  const toggleDropdown = ()=>{
    setDropdownOpen(!dropdownOpen)
  }

  
  useEffect(()=>{
    const Language = (language === 'fr') ? FRENCH:ENGLISH
    setTexts(Language)
  },[language])

  return (
    <LanguageContext.Provider value={texts}>
      {/*<div className="App">
        <Detector/>
        </div>*/}

      <div className="App">
        <Navbar
            className='navbar-horizontal navbar-dark bg-edited-dark'
            expand='lg'
        >
          <NavbarBrand color='faded' href={base_url}><img src={base_url+'logos/appsmart.png'} className='img-fluid' /></NavbarBrand>
          <Nav className="ml-lg-auto" navbar>
              <NavItem>
                <Link className='text-white' to="/demo">{texts.navbar.link3}</Link>
              </NavItem>
              <NavItem>
                <Link className='text-white p-5' to="/animator">{texts.navbar.link1}</Link>
              </NavItem>
              <NavItem>
                <Link className='text-white'  to="/detectors">{texts.navbar.link2}</Link>
              </NavItem>
              <NavItem>
              <Dropdown size='sm' className='pl-4' isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle className='p-0 btn-dark ' caret>
                  {{
                      'fr':<span class="fi fi-fr"></span>,
                      'en':<span class="fi fi-gb"></span>
                  }[language]}
                  
                  {
                    {
                      'fr': ' Français',
                      'en' : ' English'
                    } [language]
                    
                  }
                  <span class="nav-link-inner--text d-lg-none"></span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem header>
                    
                  </DropdownItem>
                  <DropdownItem onClick={()=>setLanguage('fr')}>
                    <span class="fi fi-fr"></span>
                    {' Français'}
                  </DropdownItem>
                  <DropdownItem onClick={()=>setLanguage('en')}>
                    <span class="fi fi-gb"></span>
                    {' English'}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              </NavItem>
          </Nav>
        </Navbar>
        <Outlet/>
        <br/>
        <div style={{height:'50px'}}>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <CardFooter> 
          <div className='navbar-horizontal navbar-dark bg-edited-dark'>
            <div className='row justify-content-center align-items-center'>
              <a className='px-2 p-2' target='_blanc' href='http://cerca.labo.univ-poitiers.fr/'><img width={100} src={base_url+'logos/cerca.png'} className='img-fluid' /></a>
	  <a className='px-2 p-2' target='_blanc' href='https://pprime.fr'><img width={60} src={base_url+'logos/logo_pprime.png'} className='img-fluid' /></a>
              <a className='px-2 p-2' target='_blanc' href='https://www.xlim.fr/'><img width={100} src={base_url+'logos/xlim.png'} className='img-fluid' /></a>
              <a className='px-2 p-2' target='_blanc' href='https://www.univ-poitiers.fr/'><img width={100} src={base_url+'logos/up.png'} className='img-fluid' /></a>
              <a className='px-2 p-2' target='_blanc' href='https://nouvelle-aquitaine.fr'><img width={105} src={base_url+'logos/na.png'} className='img-fluid' /></a>
              <a className='px-2 p-2' target='_blanc' href='https://europa.eu'><img width={100} src={base_url+'logos/eu.png'} className='img-fluid' /></a>
              <a className='px-2 p-2' target='_blanc' href='https://www.cnrs.fr/'><img width={100} src={base_url+'logos/logo_cnrs.svg'} className='img-fluid' /></a>
            </div>
          </div>
          <br></br>
        </CardFooter>
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
